module.exports = __webpack_public_path__ + "static/media/tg.1e7756ae.svg";